//import $ from 'jquery';
function getClientX(e) {
    if('clientX' in e) {
        return e.clientX;
    } else {
        switch(e.type) {
            case 'touchstart':
            case 'touchmove':
                return e.touches[0].clientX;
            case 'touchend':
            case 'touchcancel':
                return e.changedTouches[0].clientX;
        }
    }
}
function getClientY(e) {
    if('clientY' in e) {
        return e.clientY;
    } else {
        switch(e.type) {
            case 'touchstart':
            case 'touchmove':
                return e.touches[0].clientY;
            case 'touchend':
            case 'touchcancel':
                return e.changedTouches[0].clientY;
        }
    }
}
 

export function getDevicePagePoint (elem, event){
    let pageRect = elem.getBoundingClientRect();
    let srcEvent = event.srcEvent;
    const clientX = getClientX(srcEvent);
    const clientY = getClientY(srcEvent);
    return {
        x: clientX - pageRect.left - event.deltaX,
        y: clientY - pageRect.top - event.deltaY,
    };
}
export function getBoundingPoint (elem, clientX, clientY) {
    let elemRect = elem.getBoundingClientRect();
    return [clientX - elemRect.left, clientY - elemRect.top];
}
export function deltaDeviceRect (startPoint, deltaX, deltaY) {
    let left = startPoint[0];
    let top = startPoint[1];
    let right = left + deltaX;
    let bottom = top + deltaY;
    let temp;
    if (right < left) {
        temp = left;
        left = right;
        right = temp;
    }
    if (bottom < top) {
        temp = top;
        top = bottom;
        bottom = temp;
    }
    return {
        left,
        right,
        top,
        bottom,
    }
}
const markSelectClassName = 'fv__mark-selection-blank';
const markSelectSelector = '.' + markSelectClassName;
export function appendSelectMark ($parent, rectArray) {
    removeSelectMark($parent);
    let $frag = $(document.createDocumentFragment());
    for (let i = 0, j = rectArray.length; i < j; i++) {
        let rect = rectArray[i];
        let style = ['top:' + rect.top + 'px', 'left:' + rect.left + 'px', 'width:' + (rect.right - rect.left) + 'px', 'height:' + (rect.bottom - rect.top) + 'px'].join(';')
        $frag.append('<mark class="' + markSelectClassName + '" style="' + style + '"></mark>')
    }
    $parent.append($frag);
}
export function removeSelectMark ($parent) {
    $parent.find(markSelectSelector).remove();
}